import { Menu, MenuPopupBody } from '@/popups/menupopup/menu'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'

export interface SimpleUser {
    id: string
    email: string
    username: string
}

export const extendDashboardUserMenuPopup = ({ menu, services, session, row, navigate }: {
    menu: Menu
    services: Services
    session: CurrentSession
    row: SimpleUser
    navigate: (url: string) => void
}): Menu => {
    return menu
}